import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const TIMEZONES = [
  { id: "UTC", label: "UTC" },
  { id: "Africa/Johannesburg", label: "SAST" },
  { id: "America/New_York", label: "ET" },
  { id: "Australia/Sydney", label: "AEST" },
];

export function tzLabel(tz) {
  return TIMEZONES.find((t) => t.id === tz)?.label || "UTC";
}

export function fmtInTz(value, tz = "UTC", opts = { dateStyle: "medium", timeStyle: "short" }) {
  if (!value) return "—";
  const d = typeof value === "number" ? new Date(value * 1000) : new Date(value);
  return `${d.toLocaleString(undefined, { timeZone: tz, ...opts })} ${tzLabel(tz)}`;
}

export function timeAgo(iso) {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
}
